var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7369_104844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 20.1666C5.93692 20.1666 1.83301 16.0627 1.83301 10.9999C1.83301 5.93717 5.93692 1.83325 10.9997 1.83325C16.0624 1.83325 20.1663 5.93717 20.1663 10.9999C20.1663 16.0627 16.0624 20.1666 10.9997 20.1666ZM10.9997 18.3333C12.9446 18.3333 14.8099 17.5606 16.1851 16.1854C17.5604 14.8101 18.333 12.9448 18.333 10.9999C18.333 9.055 17.5604 7.18974 16.1851 5.81447C14.8099 4.4392 12.9446 3.66659 10.9997 3.66659C9.05475 3.66659 7.18949 4.4392 5.81422 5.81447C4.43896 7.18974 3.66634 9.055 3.66634 10.9999C3.66634 12.9448 4.43896 14.8101 5.81422 16.1854C7.18949 17.5606 9.05475 18.3333 10.9997 18.3333ZM10.083 6.41658H11.9163V8.24992H10.083V6.41658ZM10.083 10.0833H11.9163V15.5833H10.083V10.0833Z",
    fill: "#DE1414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7369_104844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformRedIcon);
export default __webpack_public_path__ + "static/media/inform-red-icon.d6b44dd852d31a1f758b2c8b3ba5efb3.svg";
export { ForwardRef as ReactComponent };